<template>
  <app-center>
    <template v-slot:page>
      You do not have permission to access this page
    </template>
  </app-center>
</template>

<script>
import AppCenter from '../widget/AppCenter.vue';

export default {
  name: 'Page403',
  components: {
    AppCenter,
  },
};
</script>
